import React from 'react';

const NavbarContext = React.createContext('navBar');

export default NavbarContext;
